export default "__VITE_ASSET__UuRjaROc__"